import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=745f3e98&"
import script from "./Invitation.vue?vue&type=script&lang=js&"
export * from "./Invitation.vue?vue&type=script&lang=js&"
import style0 from "./Invitation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Invitation.vue"
export default component.exports